import React from "react";
import axios from "react-axios";

export const defineContainer = (callbacks = [], Component) => {
  class Container extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        failure: null,
        loading: true,
        data: [],
      };
    }

    render() {
      const request = (...args) => {
        this.setState({ loading: true });
        const sources = callbacks.map((cb) => cb(axios, ...args));
        return Promise.all(sources)
          .then((callBackRes) => {
            this.setState({ failure: false, loading: false, data: callBackRes });
            const [data1, data2, data3] = callBackRes;
            return { data1, data2, data3 };
          })
          .catch((e) => this.setState({ failure: e, loading: false }));
      };
      const props = {
        request,
        ...this.state,
        ...this.props,
        axios,
      };
      return <Component {...props} />;
    }
  }
  return Container;
};

export const CreateMultiContainer = (callbacks, Component) => {
  const Container = defineContainer(callbacks, Component);
  return Container;
};
